'use strict';

var UserProfileDirective = function UserProfileDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/user-profile.html'),
    controller: 'UserProfileController',
    scope: {
      user: '=',
      isOwnProfile: '=',
      backToUserList: '=?'
    }
  };
};
UserProfileDirective.$inject = [];
module.exports = UserProfileDirective;